import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { Toast } from 'mint-ui'

axios.defaults.timeout = 10000
// 正式服
//let baseApiUrl = '//native.youquanyun.com/api/'
let baseApiUrl = 'http://shop.quwan.info/api/'
// 测试服
// let baseApiUrl = '//unative.bangyaosoft.cn/api/'
// release 环境
// let baseApiUrl = '//release.youquanyun.com/api/'
axios.defaults.baseURL = baseApiUrl
const CancelToken = axios.CancelToken
let cancel = {}
let promiseArr = {}
// 设置默认请求头
axios.defaults.headers = {
  // 'X-Requested-With': 'XMLHttpRequest',
  'Content-type': 'application/x-www-form-urlencoded'
}
// 序列化参数
axios.defaults.transformRequest = (data) => {
  data = qs.stringify(data)
  return data
}
// 设置axios请求拦截器开始
axios.interceptors.request.use(
  config => {
      // 你需要在这里取到你设置好的token的值
      var token = localStorage.getItem("token")
      if (token) {
          // 这里将token设置到headers中，header的key是Authorization，这个key值根据你的需要进行修改即可
          config.headers.token = token;
      }
      return config
  },
  error => {
      return Promise.reject(error)
  }
);
// 设置axios请求拦截器结束

export default {
  // get请求
  get (url, param,show) {
    return new Promise((resolve, reject) => {
      if (!param) {
        param = {}
      }
      axios({
        method: 'get',
        url,
        data:'',
        params: param,
      }).then(res => {
        if (res.code === 0) {
          resolve(res)
        }else {
          if (show) {
            resolve(res)
          } else {
            // Vue.$vux.toast.text(res.msg)
          }
        }
      }).catch(error => {

      })
    })
  },
  // post请求
  post (url, param, show) {
    return new Promise((resolve, reject) => {
      if (!param || JSON.stringify(param) == "{}") {
        // 当传参为空或者为空对象时，都处理为空字符串，为了方便CancelToken接口取消功能。
        param = ''
      }

      axios({
        method: 'post',
        url,
        data: param,
        params:'',
      }).then(res => {

        if (!res) {
          return
        }
        if (res.data.code === 0) {
          resolve(res)
        } else {
          if (show) {
            resolve(res)
          } else {
            Toast({
             message: res.data.msg
           })
          }
        }
      }).catch(error => {


        console.log(error)
        if(error.message.errorType!='cancel'){
          // Vue.$vux.toast.text(error.message, 'top')
          resolve(error)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/http.js